'use client';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Global error:', error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="container py-4">
          <div className="alert alert-danger">
            <h4>حدث خطأ في النظام</h4>
            <p>عذراً، حدث خطأ غير متوقع في النظام. يرجى المحاولة مرة أخرى.</p>
            <button
              onClick={reset}
              className="btn btn-primary"
            >
              المحاولة مرة أخرى
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
